import React from 'react'

const useIsInViewport = refElement => {
	const [directionName, setDirectionName] = React.useState('')

	React.useEffect(() => {
		const rect = refElement.current.getBoundingClientRect()
		if (
			!(
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
			)
		) {
			const directionNames = []
			if (rect.top >= 0 === false) {
				directionNames.push('shiftDown')
			}
			if (rect.left >= 0 === false) {
				directionNames.push('shiftRight')
			}
			if (
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) ===
				false
			) {
				directionNames.push('shiftUp')
			}
			if (
				rect.right <= (window.innerWidth || document.documentElement.clientWidth) ===
				false
			) {
				directionNames.push('shiftLeft')
			}

			setDirectionName(directionNames.join(' '))
		}
	}, [refElement])

	return { directionName }
}

export default useIsInViewport
